import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { LoadingSpinner } from '../../../components/base';
import { AppRedirectPageWrapper } from './styles';
import { selectOrganization, selectApp, } from '@project/containers/Root/actions';
import storageService from '@project/utils/storageService';
import { useDispatch, useSelector } from 'react-redux';
import { selectSelectedApp } from '../../../store/selectedApp/selectors';
import { makeSelectOrganizations } from '../../Root/selectors';
import { useHistory } from 'react-router-dom';
import { loadSelectedApp } from '../../../store/selectedApp/actions';
import { selectMe } from '../../Root/selectors';
import { Redirect } from 'react-router-dom';
var AppRedirectPage = function () {
    var _a, _b, _c, _d;
    var dispatch = useDispatch();
    var history = useHistory();
    var pathNameArray = (_a = history.location.pathname) === null || _a === void 0 ? void 0 : _a.split('/');
    var appId = pathNameArray[2];
    var allOrganizations = useSelector(makeSelectOrganizations());
    useEffect(function () {
        appId && dispatch(loadSelectedApp(appId));
    }, [appId, dispatch]);
    var selectedApp = useSelector(selectSelectedApp);
    var selectedAppOrgIdSplit = (_c = (_b = selectedApp === null || selectedApp === void 0 ? void 0 : selectedApp.app) === null || _b === void 0 ? void 0 : _b.owner) === null || _c === void 0 ? void 0 : _c.split(':');
    var selectedAppOrgId = selectedAppOrgIdSplit
        ? selectedAppOrgIdSplit[1]
        : null;
    var me = useSelector(selectMe);
    var currentOrganization = storageService.getItem('selectedOrganizationId');
    dispatch(selectApp(appId));
    if (selectedAppOrgId && selectedAppOrgId !== currentOrganization) {
        dispatch(selectOrganization(selectedAppOrgId, me === null || me === void 0 ? void 0 : me.id));
    }
    return appId === 'new' ? (_jsx(Redirect, { to: "/organizations" })) : selectedAppOrgId ? (_jsx(Redirect, { to: "/organizations/".concat(selectedAppOrgId).concat(history.location.pathname) })) : (appId === '' || !appId) && currentOrganization ? (_jsx(Redirect, { to: "/organizations/".concat(currentOrganization).concat(history.location.pathname) })) : (appId === '' || !appId) && (allOrganizations === null || allOrganizations === void 0 ? void 0 : allOrganizations.length) > 0 ? (_jsx(Redirect, { to: "/organizations/".concat((_d = allOrganizations[0]) === null || _d === void 0 ? void 0 : _d.id, "/apps") })) : appId === '' || !appId ? (_jsx(Redirect, { to: "/organizations" })) : (_jsx(AppRedirectPageWrapper, { children: _jsx(LoadingSpinner, {}) }));
};
export default AppRedirectPage;
